module.exports = __webpack_public_path__ + "assets/img/202111-5.8681514c.png";